import React from 'react';
import AnimatedBackground from './components/AnimatedBackground';
import GrainOverlay from './components/GrainOverlay';
import ScrollProgress from './components/ScrollProgress';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Problems from './components/Problems';
import Services from './components/Services';
import Process from './components/Process';
import LiveActivity from './components/LiveActivity';
import CaseStudies from './components/CaseStudies';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useReveal } from './hooks/useReveal';
import './styles/App.css';

const App: React.FC = () => {
  useReveal();

  return (
    <div className="app">
      <AnimatedBackground />
      <ScrollProgress />
      <div className="content-wrapper">
        <Header />
        <Hero />
        <TrustBar />
        <Problems />
        <Services />
        <Process />
        <LiveActivity />
        <CaseStudies />
        <About />
        <FAQ />
        <Contact />
        <Footer />
      </div>
      <GrainOverlay />
    </div>
  );
};

export default App;
